import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import useSWR from 'swr';

import { ADMIN_ACCESS_TOKEN_KEY } from '../../../App';

type licenseType = {
  setLicenseInfo?: Dispatch<SetStateAction<any>>;
};

const LicenseInfo = ({ setLicenseInfo }: licenseType) => {
  const [accessToken, setAccessToken] = useState('');
  const [userDate, setUserData] = useState<any>();
  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  const url = `api/license`;

  const { data, error } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  // 라이센스 정보 전달 - create account 시 생성 유저 유효성을 위함
  // if (setLicenseInfo && data?.result) {
  //   setLicenseInfo(data.result);
  // }

  // 라이센스 정보 전달 - create account 시 생성 유저 유효성을 위함, data가 업데이트되면 setLicenseInfo 호출
  useEffect(() => {
    if (data?.result && setLicenseInfo) {
      setLicenseInfo(data.result);
    }
  }, [data, setLicenseInfo]);

  useEffect(() => {
    if (data) {
      setUserData(data.result);
    }
  }, [data]);

  if (error) {
    return <div>failed to load</div>;
  }

  if (!data) {
    return <div>loading...</div>;
  }

  return (
    <LicenseInfoWrapper>
      Number of user available :
      {userDate?.isUnlimitedUser ? (
        'Unlimited'
      ) : (
        <>
          <b>{userDate?.activatedUserCount}</b>/{userDate?.limitUser}
        </>
      )}
    </LicenseInfoWrapper>
  );
};

const LicenseInfoWrapper = styled.div`
  position: absolute;
  right: 0;
  top: -20px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #777777;
  b {
    color: #7fe200;
  }
`;
export default LicenseInfo;
